import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import { IOrganisationIndexCategory } from "../model/OrganisationIndexCategory";
import OrganisationIndexCategoryMapper from "../service/OrganisationIndexCategoryMapper";
import OrganisationIndexCategoryParamMapper from "../service/OrganisationIndexCategoryParamMapper";

export default class CreateOrganisationIndexCategoryInteractor {
  private createResource: CreateResourceInteractor<IOrganisationIndexCategory>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IOrganisationIndexCategory) {
    return this.createResource.execute(
      `organisations/${model.organisationId}/index-categories`,
      OrganisationIndexCategoryMapper,
      OrganisationIndexCategoryParamMapper,
      model,
      undefined,
      false
    );
  }
}
